import { type ElectionBase, electionBaseFields } from './electionBase';

export const votingCodeFields = `
  id
  code
  election {
    ${electionBaseFields}
  }
`;

export interface VotingCode {
  id: string;
  code: string;
  election: ElectionBase;
}
